import React from 'react';

import { ExternalLink } from '../../../../components/ExternalLink';

import './index.scss';

interface ExternalLinksContentProps {
  buildkiteUrl: string;
  gitHubUrl: string;
}

const ExternalLinksContent: React.FunctionComponent<ExternalLinksContentProps> = ({buildkiteUrl, gitHubUrl}) => {
  return (
    <React.Fragment>
      <ExternalLink href={buildkiteUrl} className="buildkite-link">View build</ExternalLink>
      <ExternalLink href={gitHubUrl} className="github-link">View commit</ExternalLink>
    </React.Fragment>
  )
}

export default ExternalLinksContent;